import {
  CREATE_LOCATION,
  CREATE_LOCATION_SUCCESS,
  CREATE_LOCATION_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const createLocationReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_LOCATION:
      return { ...state, loading: true };
    case CREATE_LOCATION_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case CREATE_LOCATION_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default createLocationReducer;
